import { makeAutoObservable } from 'mobx';
import setObjectKetValue from 'helpers/setObjectKetValue';
import { getTenancyMinDate } from 'config/dataDefaults';

class TenancyAddEditState {
  constructor(initialData) {
    this.state = initialData;
    makeAutoObservable(this);

    this.tenancyMinDate = getTenancyMinDate();
  }

  state = null;

  setState(key, value) {
    console.log(key, value);
    let localValue = value;
    // if (key === 'dates.startDate' || key === 'dates.endDate') {
    //   localValue = toSwiftDate(value);
    // }
    setObjectKetValue(this.state, key, localValue);
  }
}

export default TenancyAddEditState;
